import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const useBrickShapesQuery = () => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'brickShapes',
    params: [],
    retry: false,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useBrickShapesQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching brick shapes')

      spawnErrorToast(t('error.brickShapesQuery'))

      return false
    }
  })
}
